import { EVENTS } from '../../../utils/eventBus';
import type { TipDefinition } from '../types';

/**
 * 所有 Tips 定義
 *
 * 新增 Tip：在此物件中新增一筆定義即可
 */
export const tips: Record<string, TipDefinition> = {
  // === Event Modal ===
  'event-allday-toggle': {
    id: 'event-allday-toggle',
    content: 'Toggle to switch between all-day and timed event',
    position: 'bottom',
    arrowAlign: 'end',
    autoMarkOnEvent: EVENTS.UI.ALLDAY_TOGGLED,
  },

  // === Today 頁面 ===
  'today-ai-plan': {
    id: 'today-ai-plan',
    content: 'Tap to plan your day based on your tasks and goals',
    position: 'bottom',
    arrowAlign: 'center',
    autoMarkOnEvent: [EVENTS.UI.AI_SUGGESTION_TRIGGERED, EVENTS.UI.TODAY_QUICK_CREATE_OPENED],
  },

  // === Calendar 頁面 ===
  'calendar-planned-layer': {
    id: 'calendar-planned-layer',
    content: 'Drag tasks from here to the calendar to schedule them',
    position: 'left',
    arrowAlign: 'start',
    autoMarkOnEvent: EVENTS.UI.TASK_DROPPED_TO_CALENDAR,
  },
  'calendar-planned-layer-mobile': {
    id: 'calendar-planned-layer-mobile',
    content: 'Tap a task, then choose a time slot to schedule it',
    position: 'top',
    arrowAlign: 'start',
    autoMarkOnEvent: EVENTS.UI.TASK_SCHEDULED_FROM_LAYER,
  },
  'calendar-click-slot': {
    id: 'calendar-click-slot',
    content: 'Click any empty slot to quickly create a TimeBox or Event',
    position: 'top',
    arrowAlign: 'center',
    autoMarkOnEvent: EVENTS.UI.QUICK_CREATE_MODAL_OPENED,
  },
  'calendar-ai-planning': {
    id: 'calendar-ai-planning',
    content: 'Get a starting schedule from your tasks. Adjust to make it yours.',
    position: 'bottom',
    arrowAlign: 'end',
    autoMarkOnEvent: EVENTS.UI.AI_PLAN_TRIGGERED,
  },

  // === Tasks 頁面 ===
  'tasks-card-actions': {
    id: 'tasks-card-actions',
    content: 'Tap a task to see details, analyze, or split into subtasks',
    position: 'bottom',
    arrowAlign: 'start',
    autoMarkOnEvent: EVENTS.UI.TASK_DETAIL_OPENED,
  },

  // === Captures 頁面 ===
  'captures-inbox-filter': {
    id: 'captures-inbox-filter',
    content: 'Inbox shows only unprocessed captures. Clear them as you go',
    position: 'bottom',
    arrowAlign: 'start',
    autoMarkOnEvent: EVENTS.UI.INBOX_FILTER_CLICKED,
  },

  // === Goals 頁面 ===
  'goals-card-actions': {
    id: 'goals-card-actions',
    content: 'Hover or tap a goal card to see quick actions like pause, complete, or edit',
    position: 'bottom',
    arrowAlign: 'start',
    autoMarkOnEvent: EVENTS.UI.GOAL_ACTIONS_OPENED,
  },
};

/**
 * 各頁面的 Tips 佇列（有序）
 *
 * 用戶進入頁面時，會依序顯示佇列中的 Tips
 * 關閉一個 Tip 後，延遲約 0.8 秒顯示下一個
 */
export const pageTipQueues: Record<string, string[]> = {
  today: ['today-ai-plan'],
  // calendar-planned-layer 與 calendar-planned-layer-mobile 互斥（tipAliases 處理），
  // 關閉其中一個會自動連帶標記另一個，確保佇列不因裝置差異重複顯示
  calendar: ['calendar-planned-layer', 'calendar-planned-layer-mobile', 'calendar-click-slot', 'calendar-ai-planning'],
  tasks: ['tasks-card-actions'],
  captures: ['captures-inbox-filter'],
  goals: ['goals-card-actions'],
};

/**
 * 互斥 Tip 別名（裝置互斥）
 *
 * 同一概念在不同裝置寬度有不同的 Tip，標記其中一個為已看過時，
 * 自動連帶標記別名，避免使用者切換裝置或刷新後重複看到。
 */
export const tipAliases: Record<string, string[]> = {
  'calendar-planned-layer':        ['calendar-planned-layer-mobile'],
  'calendar-planned-layer-mobile': ['calendar-planned-layer'],
};
